import type { ISignedUrlResult } from '../stylesheet.service';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UploadStatus, ValidatorService } from '@shared/models/fileupload';
import { Subject, take } from 'rxjs';
import { StylesheetService } from '../stylesheet.service';

@Injectable({
	providedIn: 'root',
})
export class StylingValidatorService implements ValidatorService {
	private statusSubject: Subject<UploadStatus> = new Subject<UploadStatus>();
	public statusSubject$ = this.statusSubject.asObservable();

	constructor(
		private translate: TranslateService,
		private stylesheetService: StylesheetService,
	) {}

	validate(files: File[], fields: object[], context: string) {
		if (files && files.length > 0) {
			let error = files.length > 1;
			if (error) {
				const errorMessage = this.translate.instant('administration.drawings.upload.error.only-one-file');
				this.statusSubject.next({ status: 'client_error', data: errorMessage });
				return;
			}
			error = files[0].name.trim().toLowerCase() !== `${context.trim().toLowerCase()}.css`;
			if (error) {
				const errorMessage = this.translate.instant(`administration.drawings.upload.error.invalid-filename-${context}`);
				this.statusSubject.next({ status: 'client_error', data: errorMessage });
				return;
			}
			// Request a signed PUT URL, then upload the selected file to that URL
			this.stylesheetService
				.getStylingUrl('PUT', context)
				.pipe(take(1))
				.subscribe({
					next: (res: ISignedUrlResult) => {
						this.stylesheetService.uploadStylingFile(files[0], res.result.url).subscribe({
							next: (uploadStatus) => {
								this.statusSubject.next({
									status: 'success',
									data: uploadStatus,
								});
							},
							error: (error: Error) => {
								console.log('upload error', error);
								this.statusSubject.next({
									status: 'error',
									data: error.message,
								});
							},
						});
					},
					error: (error: Error) => {
						console.log('upload error', error);
						this.statusSubject.next({
							status: 'error',
							data: error.message,
						});
					},
				});
		}
	}
}
